// This component should be updated in case we add a new srpType function in the future
/* eslint-disable */
(function (global, factory) {
    "use strict";

    if ("function" === typeof define && define.amd) {
        // If supports for AMD is available return the value to the AMD Loader
        // and to the global (window) object in case any JS module.
        define('searchTypeHelper',[], function () {
            global.searchTypeHelper = factory(global);
            return global.searchTypeHelper;
        });
    } else if ("object" === typeof exports) {
        // If supports for Common JS is available export the module
        // and pass is value to the global (window) object in case non Common JS code 
        // is expected to work
        module.exports = (global.searchTypeHelper = factory(global));
    } else {
        // If not support for AMD or Common JS is available register the module in the global scope.
        global.searchTypeHelper = factory(global);
    }
})("undefined" !== typeof window ? window : {}, function (root) {
    var CONFIGURATION = (function () {
        var objectToReturn = {};
        var functions = {
            CommunityResults: {
                "nhs": "/communities/",
                "cna": "/comunidades/",
                SingleFamily: {
                    "nhs": "/single-family-communities/",
                    "cna": "/comunidades-unifamiliares/"
                }
            },
            CondoDevelopments: {
                "nhs": "/condo-developments/",
                "cna": "/condominios/"
            },
            HomeResults: {
                "nhs": "/homes/",
                "cna": "/casas/",
                Floorplans: {
                    "nhs": "/floor-plans/",
                    "cna": "/planos/"
                },
                Model: {
                    "nhs": "/model-homes/",
                    "cna": "/casas-modelo/"
                },
                SingleFamily: {
                    "nhs": "/single-family-homes/",
                    "cna": "/casas-unifamiliares/"
                }
            },
            CondoTownHomes: {
                "nhs": "/condo-townhomes/",
                "cna": "/complejos/",
                Floorplans: {
                  "nhs": "/floor-plans/",
                  "cna": "/planos/"
                },
                Model: {
                  "nhs": "/model-homes/",
                  "cna": "/casas-modelo/"
                }
            },
            BuilderResults: {
                "nhs": "/builders/",
                "cna": "/constructores/"
            },
            BoylResults: {
                "nhs": "/on-your-lot/",
                "cna": "/construya-en-su-lote/"
            },
            CustomHomes: {
                "nhs": "/custom-homes/",
                "cna": "/casas-personalizadas/"
            },
            CustomBuilders: {
                "nhs": "/custom-builders/",
                "cna": "/constructoras-personalizadas/"
            },
            ManufacturedResults: {
                "nhs": "/manufactured/",
                "cna": "/prefabricadas/"
            },
            ManufacturedHomes: {
                "nhs": "/manufactured-homes/",
                "cna": "/casasprefabricadas/",
                Floorplans: {
                  "nhs": "/floor-plans/",
                  "cna": "/planos/"
                },
                Model: {
                  "nhs": "/model-homes/",
                  "cna": "/casas-modelo/"
                }
            },
            AmenityResults: {
                "nhs": "/state/"
            }
        };

        objectToReturn["getAllFunctions"] = function () { return functions; };

        for (var srpFunction in functions) {
            if (functions.hasOwnProperty(srpFunction)) {
                objectToReturn[srpFunction] = srpFunction;
            }
        }

        return Object.freeze(objectToReturn);
    })();

    /**
     * Flag to determine if current page is NHS or CNA.
     * @private
     * @returns {boolean} True if url is NHS, false if not.
     */
    var isNhsPage = function () {
        return root.location.href.indexOf(".newhomesource.com") > -1;
    }

    /**
     * Gets an object with all srp function strings for NHS or for CNA.
     * @description For nhs returns {CommunityResults: "/communities/", CondoDevelopments: "/condo-developments/", ... }.
     *              For cna returns {CommunityResults: "/comunidades/", CondoDevelopments: "/condominios/", ... }.
     * @returns {object} An object containing the srp functions.
     */
    var getAllSrpFunctions = function () {
        var allFunctions = CONFIGURATION.getAllFunctions();
        let urlKey = isNhsPage() ? 'nhs' : 'cna';
        var currentFunctions = {};

        for (var srpFunction in allFunctions) {
            const entry = allFunctions[srpFunction];
            const localizedSrpFunction = entry[urlKey];

            if (localizedSrpFunction) {
                currentFunctions[srpFunction] = localizedSrpFunction;
            }

            Object.keys(entry).forEach((key) => {
                
                if (typeof entry[key] === 'object' && entry[key][urlKey])
                {
                    currentFunctions[`${srpFunction}__${key}`] = entry[key][urlKey];
                }
            })
        }

        return currentFunctions;
    }

    /**
     * Gets an object with the names of all srpTypes.
     * @example
     * // returns { CommunityResults: "CommunityResults", HomeResults: "HomeResults", CondoDevelopments: "CondoDevelopments", ... }
     * @returns {object} A json object with the key/values of all valid srpTypes.
     */
    var getAllSrpTypes = function () {
        var localCopy = Object.assign({}, CONFIGURATION);
        delete localCopy["getAllFunctions"];
        return CONFIGURATION;
    }

    /**
     * Gets the srp function from the current srp url.
     * @returns {string} The current srp function, empty if the url doesn't match any current valid functions.
     */
    var getSrpFunction = function (url) {
        if (!url) {
            url = root.location.href;
        }

        var allSrpFunctions = getAllSrpFunctions();

        for (var srpFunction in allSrpFunctions) {
            if (allSrpFunctions.hasOwnProperty(srpFunction)) {
                var currentFunction = allSrpFunctions[srpFunction];

                if (url.indexOf(currentFunction) > -1) {
                    return currentFunction;
                }
            }
        }

        return "";
    }

    /**
     * Get the srpType name based on the url search function. Uses the current url function if a function parameter is not provided.
     * @param {string} srpFunction The url search function.
     * @returns {string} The current srpType if the function matches any valid srpType, empty if otherwise.
     */
    var getSrpType = function (srpFunction) {
        if (!srpFunction) {
            srpFunction = getSrpFunction();
        }

        var srpFunctions = getAllSrpFunctions();

        for (var currentSrpFunction in srpFunctions) {
            if (srpFunctions.hasOwnProperty(currentSrpFunction) &&
                srpFunctions[currentSrpFunction] === srpFunction) {
                    const hierarchy = currentSrpFunction.split('__');
                    return hierarchy[0];
            }
        }

        return "";
    }

    /**
     * Takes an url and updates it with the new srp function part.
     * @param {string} newFunction The function to which we want to update the current url.
     * @param {string=} url The url to update. If not provided the current url is used. 
     */
    var updateUrlFunction = function (newFunction, url) {
        if (!url) {
            url = root.location.href;
        }

        var currentSrpFunction = getSrpFunction(url);

        if (currentSrpFunction !== newFunction && newFunction !== "") {
            var newUrl = url.replace(currentSrpFunction, newFunction);
            root.history.pushState({}, "", newUrl);
            return true;
        }

        return false;
    }

    /**
     * Removes a query parameter from a url string.
     * @param {string} parameter The query parameter to remove from the url.
     * @param {string=} url The url from which the query parameter should be removed.
     *      If not provided, the current url will be used instead.
     * @returns {string} Url with the query parameter removed.
     */
    var removeQueryParamFromUrl = function (parameter, url) {
        if (!url) {
            url = root.location.href;
        }

        var thisParam = "?" + parameter;

        // Case 1. There's only one query parameter.
        // Example: Query parameter "test=1" in url "www.nhs.com/?test=1".
        if (url.indexOf(thisParam) !== -1 && url.endsWith(thisParam)) {
            return url.replace(thisParam, "");
        }

        // Case 2. Query parameter is the first of several parameters.
        // Example: Query parameter "one=true" in "www.nhs.com/?one=true&two=true".
        thisParam = "?" + parameter + "&";

        if (url.indexOf(thisParam) !== -1) {
            return url.replace(parameter + "&", "");
        }

        // Case 3. Query parameter is between other parameters.
        // Example: Query parameter "true=2" in "www.nhs.com/?one=1&two=2&three=3".
        thisParam = "&" + parameter + "&";

        if (url.indexOf(thisParam) !== -1) {
            return url.replace("&" + parameter, "");
        }

        // Case 4. Query parameter is the last of several parameters.
        // Example: Query parameter "c=false" in "www.nhs.com/a=false&b=true&c=false".
        thisParam = "&" + parameter;

        if (url.indexOf(thisParam) !== -1 && url.endsWith(thisParam)) {
            return url.replace(thisParam, "");
        }

        return url;
    }

    /**
     * Gets a flag indicating if the srpType is a regular community srpType.
     * @param {string} srpType The srpType to check.
     * @returns {boolean} True if the srp is a regular community srpType, false otherwise.
     */
    var isCommunitySearchType = function (srpType) {
        return srpType === CONFIGURATION.CommunityResults ||
               srpType === CONFIGURATION.CondoDevelopments;
    }

    /**
    * Gets a flag indicating if the srpType is any type of community srpType.
    * @param {string} srpType The srpType to check.
    * @returns {boolean} True if the srp is any kind of community srpType, false otherwise.
    */
    var isAnyCommunitySearchType = function (srpType) {
        return srpType === CONFIGURATION.CommunityResults ||
               srpType === CONFIGURATION.CondoDevelopments ||
               srpType === CONFIGURATION.BoylResults ||
               srpType === CONFIGURATION.ManufacturedResults ||
               srpType === CONFIGURATION.AmenityResults;
    }

    /**
    * Gets a flag indicating if the srpType is a regular home srpType.
    * @param {string} srpType The srpType to check.
    * @returns {boolean} True if the srp is a regular home srpType, false otherwise.
    */
    var isHomeSearchType = function (srpType) {
        return srpType === CONFIGURATION.HomeResults ||
               srpType === CONFIGURATION.CondoTownHomes;
    }

    /**
        * Gets a flag indicating if the srpType is any type of home srpType.
        * @param {string} srpType The srpType to check.
        * @returns {boolean} True if the srp is any kind of home srpType, false otherwise.
        */
    var isAnyHomeSearchType = function (srpType) {
        return srpType === CONFIGURATION.HomeResults ||
               srpType === CONFIGURATION.CondoTownHomes ||
               srpType === CONFIGURATION.CustomHomes ||
               srpType === CONFIGURATION.ManufacturedHomes;
    }

    /**
    * Gets a flag indicating if the srpType is a builder results srpType.
    * @param {string} srpType The srpType to check.
    * @returns {boolean} True if the srp is a builder results srpType, false otherwise.
    */
    var isBuilderSearchType = function (srpType) {
        return srpType === CONFIGURATION.BuilderResults;
    }

    /**
    * Gets a flag indicating if the srpType is a custom srpType.
    * @param {string} srpType The srpType to check.
    * @returns {boolean} True if the srp is a custom srpType, false otherwise.
    */
    var isCustomSearchType = function (srpType) {
        return srpType === CONFIGURATION.BoylResults ||
               srpType === CONFIGURATION.CustomHomes;
    }

    /**
    * Gets a flag indicating if the srpType is a custom builder srpType.
    * @param {string} srpType The srpType to check.
    * @returns {boolean} True if the srp is a custom builder srpType, false otherwise.
    */
    var isCustomBuilderSearchType = function (srpType) {
        return srpType === CONFIGURATION.CustomBuilders;
    }

    /**
    * Gets a flag indicating if the srpType is a manufactured srpType.
    * @param {string} srpType The srpType to check.
    * @returns {boolean} True if the srp is a manufactured srpType, false otherwise.
    */
    var isManufacturedSearchType = function (srpType) {
        return srpType === CONFIGURATION.ManufacturedResults ||
               srpType === CONFIGURATION.ManufacturedHomes;
    }

    /**
    * Gets a flag indicating if the srpType is a manufactured or custom srpType.
    * @param {string} srpType The srpType to check.
    * @returns {boolean} True if the srp is a manufactured or custom srpType, false otherwise.
    */
    var isCustomOrManufacturedSearchType = function (srpType) {
        return isCustomSearchType(srpType) || isCustomBuilderSearchType(srpType) || isManufacturedSearchType(srpType)
    }

    /**
     * Gets the SRP type from the url.
     * @param {string} url The url we want to check.
     * @returns The SRP type string value of the url.
     */
    var getSrpTypeFromUrl = function (url){
        const srpFunction = this.getSrpFunction(url);
        const srpType = this.getSrpType(srpFunction);

        return srpType;
    }

    return {
        CommunityResults: CONFIGURATION.CommunityResults,
        CondoDevelopments: CONFIGURATION.CondoDevelopments,
        HomeResults: CONFIGURATION.HomeResults,
        CondoTownHomes: CONFIGURATION.CondoTownHomes,
        BuilderResults: CONFIGURATION.BuilderResults,
        BoylResults: CONFIGURATION.BoylResults,
        CustomHomes: CONFIGURATION.CustomHomes,
        CustomBuilders: CONFIGURATION.CustomBuilders,
        ManufacturedResults: CONFIGURATION.ManufacturedResults,
        ManufacturedHomes: CONFIGURATION.ManufacturedHomes,
        AmenityResults: CONFIGURATION.AmenityResults,
        getSrpFunction: getSrpFunction,
        getAllSrpFunctions: getAllSrpFunctions,
        updateUrlFunction: updateUrlFunction,
        removeQueryParamFromUrl: removeQueryParamFromUrl,
        getAllSrpTypes: getAllSrpTypes,
        getSrpType: getSrpType,
        getSrpTypeFromUrl: getSrpTypeFromUrl,
        isBuilderSearchType: isBuilderSearchType,
        isCommunitySearchType: isCommunitySearchType,
        isAnyCommunitySearchType: isAnyCommunitySearchType,
        isHomeSearchType: isHomeSearchType,
        isAnyHomeSearchType: isAnyHomeSearchType,
        isCustomSearchType: isCustomSearchType,
        isCustomBuilderSearchType: isCustomBuilderSearchType,
        isManufacturedSearchType: isManufacturedSearchType,
        isCustomOrManufacturedSearchType: isCustomOrManufacturedSearchType
    };
});
